import { layerListEntryUuid } from '../../../shared/array-types.js';

type Row = Record<string, unknown>;
/** Fragment-local effect flag (UUID list or checkbox), unioned with the caster's typed list. */
export function ignoresDamageTypeResistance(damageTypeId: string, casterTypes: ReadonlySet<string> | undefined,
  fragment: Row | undefined, read: { entries: (row: Row, key: string) => unknown[] }): boolean {
  return casterTypes?.has(damageTypeId.toUpperCase()) === true || !!fragment
    && read.entries(fragment, 'effect_ignores_damage_type_resistance').some(entry => entry === 1 || entry === '1'
      || layerListEntryUuid(entry).toUpperCase() === damageTypeId.toUpperCase());
}
